import { useAzureFileUpload } from '@repo/file-uploader';
import { useEffect } from 'react';
import { globalToastService } from '@repo/atomic-components';

export const usePreventUnloadWhenLoading = () => {
  const { uploadList } = useAzureFileUpload();

  useEffect(() => {
    const handleBeforeUnload = (event: BeforeUnloadEvent) => {
      const message = "Documents are still being uploaded, are you sure you'd like to leave the page?";

      globalToastService.show({
        closable: true,
        severity: 'warn',
        summary: 'Uploaded Medical Records',
        detail: message,
        life: 15000,
      });

      event.preventDefault();
      event.returnValue = message;
    };

    const hasUnfinishedUploads = uploadList.some((file) => {
      /** If progress or status is missing, treat as finished */
      if (typeof file?.progress !== 'number' || typeof file?.status !== 'string') return false;

      return file.progress !== 100 || file.status !== 'success';
    });

    if (hasUnfinishedUploads) {
      window.addEventListener('beforeunload', handleBeforeUnload);
    } else {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    }

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [uploadList]);
};
